export const DEFAULT_LANGUAGE_ID = 1;
export const PIN_SIZE = 6;
export const rltLocale = 177;

export const HTTP_STATUS_CODE = {
    'SUCCESS': 200,
    'FAIL': 500
}

export const VALIDATE_USER_RESPONSE_TYPES = {
    REGISTERED_AND_MAPPED: 'UserAlreadyRegisteredOnAnotherDevice',
    REGISTERED_AND_NOT_MAPPED: 'UserAlreadyRegisteredNotMappedToAnyDevice',
    NON_REGISTERED: 'DisplayContactScreen',
    INVALID_EMPLOYEE: 'InvalidEmployeeID',
    REGISTERED_USER: 'RegisteredUser',
    INVALID_COMPANY: 'InValid Company Code',
    VALID_EMPLOYEE_ID: 'companyEmployeeIDNum'
};

export const MOODLE_REGISTRATION_FLOW = {
    LANDING_PAGE: 'LANDING_PAGE',
    COMPANY_INPUT_PAGE: 'COMPANY_INPUT_PAGE',
    EMPLOYEE_INPUT_PAGE: 'EMPLOYEE_INPUT_PAGE',
    CONFIRMATION_PAGE: 'CONFIRMATION_PAGE',
    LOGIN_PAGE: 'LOGIN_PAGE',
    SECURITY_PIN_PAGE: 'SECURITY_PIN_PAGE',
    SECURITY_QUESTION_PAGE: 'SECURITY_QUESTION_PAGE'
};

export const MOODLE_RESET_PIN_FLOW = {
    ACCOUNT_DETAILS_PAGE: 'ACCOUNT_DETAILS_PAGE',
    RESET_PIN_FLOW_SECURITY_PIN_PAGE: 'RESET_PIN_FLOW_SECURITY_PIN_PAGE',
    RESET_PIN_FLOW_SECURITY_QUESTION_PAGE: 'RESET_PIN_FLOW_SECURITY_QUESTION_PAGE'
};

export const MOODLE_REGISTRATION_NAVIGATION_MAPPING = {
    0: 'LANDING_PAGE',
    1: 'COMPANY_INPUT_PAGE',
    2: 'EMPLOYEE_INPUT_PAGE',
    3: 'CONFIRMATION_PAGE',
    4: 'SECURITY_PIN_PAGE',
    5: 'SECURITY_QUESTION_PAGE'
};

export const MOODLE_REGISTRATION_PATH_NAME = {
    OPENING_PAGE: '',
    COMPANY_PAGE: '/e_learning/company',
    EMPLOYEE_PAGE: '/e_learning/employee',
    CONFIRMATION_PAGE: '/e_learning/details',
    SECURITY_QUESTION_PAGE: '/e_learning/security_questions',
    SECURITY_PIN_PAGE: '/e_learning/pin'
};

export const MOODLE_RESET_PIN_MAPPING = {
    0: 'ACCOUNT_DETAILS_PAGE',
    1: 'RESET_PIN_FLOW_SECURITY_QUESTION_PAGE',
    2: 'RESET_PIN_FLOW_SECURITY_PIN_PAGE',
};

export const MOODLE_RESET_PIN_PATH_NAME = {
    OPENING_PAGE:'',
    SECURITY_QUESTION_PAGE: '/e_learning/reset_pin/answer',
    SECURITY_PIN_PAGE: '/e_learning/reset_pin/new_pin'
};